import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { FeldKategoriesQuerySorterConfig } from 'fa-kt.types';
import { FeldKategoriesService } from '../service';

@Component({
  selector: 'fa-kt-feld-kategories-sorter',
  templateUrl: './feld-kategories-sorter.component.html',
  styleUrls: ['./feld-kategories-sorter.component.css'],
})
export class FeldKategoriesSorterComponent {
  FeldKategoriesSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public feldKategories: FeldKategoriesService,
  ) {
    this.FeldKategoriesSorterConfig = FeldKategoriesQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
